/**
 * Sorts API keys alphabetically by name
 * @param {Object} account - The account object containing pylo_accounts and usage_data
 * @returns {Array} - Sorted array of [key, value] pairs
 */
export const getSortedApiKeys = (account) => {
  if (!account || !account.usage_data) return [];
  
  return Object.entries(account.usage_data)
    .sort((a, b) => {
      const accountA = account.pylo_accounts.find(acc => acc.key_id === a[0]);
      const accountB = account.pylo_accounts.find(acc => acc.key_id === b[0]);
      return accountA.name.localeCompare(accountB.name);
    });
};

/**
 * Sorts pylo accounts alphabetically by name
 * @param {Object} account - The account object containing pylo_accounts
 * @returns {Array} - Sorted array of [key, value] pairs
 */
export const getSortedPyloAccounts = (account) => {
  if (!account || !account.pylo_accounts) return [];
  
  return Object.entries(account.pylo_accounts)
    .sort((a, b) => a[1].name.localeCompare(b[1].name));
};
